function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "education_x5F_clipboard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 32",
    style: {
      enableBackground: "new 0 0 26 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "22,28 4,28 4,8 6,8 6,26 20,26 20,8 22,8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "26,32 0,32 0,4 8,4 8,6 2,6 2,30 24,30 24,6 18,6 18,4 26,4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M18,8H8V2h2.171C10.584,0.836,11.696,0,13,0s2.416,0.836,2.829,2H18V8z M10,6h6V4h-2V3 c0-0.552-0.449-1-1-1s-1,0.448-1,1v1h-2V6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationClipboard);
export default __webpack_public_path__ + "static/media/education_clipboard.71413cb97506d107f1c8849464b395c0.svg";
export { ForwardRef as ReactComponent };